import { Input, Button } from 'antd';

interface Props {
	value: string;
	onChange: (value: string) => void;
	onApply: () => void;
	placeholder?: string;
	/** Compact mode for tablet/horizontal layouts */
	compact?: boolean;
}

export const SearchInputFilter = ({
	value,
	onChange,
	onApply,
	placeholder = 'Search...',
	compact = false,
}: Props) => {
	const handleKeyDown = (e: React.KeyboardEvent) => {
		if (e.key === 'Enter') onApply();
	};

	if (compact) {
		return (
			<Input
				size="small"
				placeholder={placeholder}
				value={value}
				onChange={(e) => onChange(e.target.value)}
				onKeyDown={handleKeyDown}
				style={{ width: 160 }}
				suffix={
					<Button type="link" size="small" onClick={onApply}>
						Go
					</Button>
				}
			/>
		);
	}

	return (
		<Input
			placeholder={placeholder}
			value={value}
			onChange={(e) => onChange(e.target.value)}
			onPressEnter={onApply}
			suffix={
				<Button type="link" size="small" onClick={onApply}>
					Apply
				</Button>
			}
		/>
	);
};